import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from '../../styles/Landlord/LandlordProperties.module.css';

const API_BASE_URL = import.meta.env.VITE_API_URL;

const LandlordProperties = () => {
  const [buildings, setBuildings] = useState([]);
  const [sortOption, setSortOption] = useState('unitsDesc');

  useEffect(() => {
    const landlordUserId = localStorage.getItem("landlordUserId");

    fetch(`${API_BASE_URL}/properties/landlord/${landlordUserId}/buildings`, {
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => setBuildings(data))
      .catch(err => console.error("Fetch error:", err));
  }, []);

  const sortedBuildings = buildings.slice().sort((a, b) => {
    switch (sortOption) {
      case 'unitsDesc':
        return b.units.length - a.units.length;
      case 'occupancyRate':
        return (
          (b.units.filter(u => u.isOccupied).length / b.units.length) -
          (a.units.filter(u => u.isOccupied).length / a.units.length)
        );
      case 'miloUnits':
        return (
          b.units.filter(u => u.activeOnMILO).length -
          a.units.filter(u => u.activeOnMILO).length
        );
      case 'contractedRent':
        return (
          b.units.reduce((sum, u) => sum + u.rent, 0) -
          a.units.reduce((sum, u) => sum + u.rent, 0)
        );
      default:
        return 0;
    }
  });

  return (
    <div className={styles.propertiesContainer}>
      <div className={styles.summary}>
        <div className={styles.metricCard}>
          <span className={styles.metricValue}>{buildings.length}</span>
          <span className={styles.metricLabel}> Buildings Managed</span>
        </div>
        <div className={styles.metricCard}>
          <span className={styles.metricValue}>
            {buildings.reduce((total, b) => total + b.units.length, 0)}
          </span>
          <span className={styles.metricLabel}> Total Units</span>
        </div>
        <div className={styles.metricCard}>
          <span className={styles.metricValue}>
            {buildings.reduce((total, b) => total + b.units.filter(u => u.activeOnMILO).length, 0)}
          </span>
          <span className={styles.metricLabel}> Active MILO Listings</span>
        </div>
        <div className={styles.metricCardHighlight}>
          <span className={styles.metricValue}>5</span>
          <span className={styles.metricLabel}> Units Filled This Month 🎉</span>
        </div>
      </div>

      <div className={styles.filterBar}>
        <label>Sort By:</label>
        <select value={sortOption} onChange={(e) => setSortOption(e.target.value)} className={styles.filterDropdown}>
          <option value="unitsDesc">Largest Buildings (Most Units)</option>
          <option value="occupancyRate">Occupancy Rate</option>
          <option value="miloUnits">Most Units on MILO</option>
          <option value="contractedRent">Highest Total Rent</option>
        </select>
      </div>

      <div className={styles.buildingsList}>
        {sortedBuildings.map((building) => {
          const occupancy = ((building.units.filter(u => u.isOccupied).length / building.units.length) * 100).toFixed(0);
          const totalRent = building.units.reduce((sum, u) => sum + u.rent, 0);
          const miloUnits = building.units.filter(u => u.activeOnMILO).length;

          return (
            <Link to={`/landlord/building/${building.id}`} key={building.id} className={styles.buildingCard}>
              <h3>{building.name}</h3>
              <p>{building.address}</p>
              <div className={styles.buildingMetrics}>
                <span>Occupancy: {occupancy}%</span>
                <span>Total Contracted Rent: ${totalRent.toLocaleString()}</span>
                <span>Units Active on MILO: {miloUnits}</span>
              </div>
            </Link>
        )})}
      </div>
    </div>
  );
};

export default LandlordProperties;
